import React from "react";
import { useEosBackdrop } from "./useEosBackdrop";
import "./EosBackdrop.scss";

const EosBackdrop: React.FC = () => {
  const { spotlightRef, floorRef, isCoarsePointer } = useEosBackdrop();

  return (
    <div className="backdrop-scene" aria-hidden="true" data-testid="backdrop-scene">
      <div className="backdrop-glow" data-testid="backdrop-glow" />
      <div className="backdrop-floor-wrap">
        <div
          ref={floorRef}
          className={`backdrop-floor ${isCoarsePointer ? "" : "animate-grid-pan"}`}
          data-testid="backdrop-floor"
        />
      </div>
      <div ref={spotlightRef} className="backdrop-spotlight" data-testid="backdrop-spotlight" />
    </div>
  );
};

export default EosBackdrop;
